import { useExchangeRate } from '../../hooks/useExchangeRate';
import { Money } from '../MoneyView';

export const useResult = (amount: Money): Money | undefined => {
  const { rate } = useExchangeRate(amount.currency === 'USD' ? 'USDRUB' : 'RUBUSD');

  if (!rate || !rate.value || !amount.value) {
    return;
  }

  return {
    value: amount.value * rate.value,
    currency: rate.currency,
  };
};
